import React, { useEffect, useRef } from 'react';
import Globe from 'globe.gl';
import * as THREE from 'three';
import { feature } from 'topojson-client';

const GlobeComponent = ({ globeData }) => {
	const globeEl = useRef(null);
	const globeInstance = useRef(null);

	useEffect(() => {
		// eslint-disable-next-line
		const globe = new Globe()(globeEl.current)
			.globeMaterial(
				new THREE.MeshPhongMaterial({
					color: '#1c1e29', // Vaaleansininen väri
					shininess: 10,
				}),
			)
			.backgroundColor('rgba(0, 0, 0, 0)') // Läpinäkyvä tausta
			.polygonsData([])
			.polygonCapColor(() => 'rgba(255, 255, 255, 0)') // Läpinäkyvä maiden täyttö
			.polygonSideColor(() => 'rgba(0, 0, 0, 0.15)') // Tummat maiden sivut
			.polygonStrokeColor(() => 'rgba(255,234,148, 1)')
			.polygonAltitude(0.01)
			.pointsData(globeData)
			.pointAltitude('size')
			.pointColor('color')
			.pointRadius(0.3)
			.pointLabel('city');

		globe.controls().autoRotate = true;
		globe.controls().autoRotateSpeed = 0.2;

		const ambientLight = new THREE.AmbientLight(0xbbbbbb);
		globe.scene().add(ambientLight);

		// Fetch world data and update the globe
		fetch('110m.json')
			.then((res) => res.json())
			.then((worldData) => {
				try {
					// Convert TopoJSON to GeoJSON
					const countries = feature(worldData, worldData.objects.countries);
					
					// Make sure we have a valid GeoJSON object
					if (countries) {
						// Try to access the expected property structure
						const geoJsonFeatures = countries.features || // standard GeoJSON structure
							(Array.isArray(countries) ? countries : // already an array of features
							[countries]); // single feature
							
						globe.polygonsData(geoJsonFeatures);
					}
				} catch (err) {
					console.error('Error processing countries data:', err);
				}
			})
			.catch(err => {
				console.error('Error fetching world data:', err);
			});

		const handleResize = () => {
			globe.width(globeEl.current.clientWidth);
			globe.height(globeEl.current.clientHeight);
		};

		window.addEventListener('resize', handleResize);
		handleResize();

		globeInstance.current = globe;

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		if (globeInstance.current) {
			globeInstance.current.pointsData(globeData);
		}
	}, [globeData]);

	return <div ref={globeEl} style={{ width: '100%', height: '95%' }} />;
};

export default GlobeComponent;
